import { render, staticRenderFns } from "./IframeWarning.vue?vue&type=template&id=b4955e50&scoped=true&"
import script from "./IframeWarning.vue?vue&type=script&lang=js&"
export * from "./IframeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4955e50",
  null
  
)

export default component.exports